/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import MedicalHistoryStatus from './MedicalHistoryStatus/index'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import TysiaNotificationBadge from 'DesignSystem/TysiaNotificationBadge/index'
import Tysiav2SearchHistory from 'DesignSystem/Svgs/Tysiav2SearchHistory/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/MedicalTab/Content/Content",
  isSelected,
  colorActive,
  isHovered
  
}) {
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
let constantData = 'medical'
let aggregateData = fromAggregate.equals(tabTabValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected,
  colorActive,
  isHovered
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let colorActiveOrdtColorsGreen700 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7001 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7002 = colorActive ?? dtColorsGreen700
let colorActiveOrdtColorsGreen7003 = colorActive ?? dtColorsGreen700
let medicalHistoryAlertsValueData = fromData.useDataFormat({ viewPath,
context: 'medical_history_alerts',
format: fromFormat.listLength,
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Medical history"
 onClick={onClick}
 data="tab.tab"
 data="'medical'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 paddingRight={dtSpaceXxs}
 size="normal"
 color={dtColorsNeutral900}
>
{childProps => (
<React.Fragment>
<Tysiav2SearchHistory
{...childProps}
  viewPath={`${viewPath}/Tysiav2SearchHistory`}
 height={12}
 width={12}
 fill2={childProps.isSelected ? colorActiveOrdtColorsGreen7003 : childProps.isHovered ? colorActiveOrdtColorsGreen7002 : dtColorsNeutral400}
/>
<MedicalHistoryStatus
{...childProps}
  viewPath={`${viewPath}/MedicalHistoryStatus`}
 is_hovered={childProps.isHovered}
/>
</React.Fragment>
)}
</SubMenuTab>
<TysiaNotificationBadge
  viewPath={`${viewPath}/TysiaNotificationBadge`}
 marginRight={dtSpaceL}
 backgroundColor={dtColorsRed600}
 color={dtColorsWhite}
 data="medical_history_alerts"
 format="/Data/format.js listLength"
 text={medicalHistoryAlertsValueData}
/>
</div>
{children}
</React.Fragment>)
}